export default __webpack_public_path__ + "static/media/daily-change.4ecaf23f.svg";